import { useFormik } from "formik";
import React, { useState } from "react";
import Select from "react-select";
import { reasonSchema } from "../../../validations/reasonValidation";
import {
	useCreateReportReasons,
	useGetCoreReportTypes,
	useUpdateReportReasons,
} from "../../../queryHooks";
import { useEffect } from "react";
import CS from "../../../services/commonService";
import { useStore } from "../../../zustand/store";

const AddUpdate = ({ item, onSuccessRefetch }) => {
	const setLoading = useStore((state) => state.setLoading);
	const [typesOptions, setTypesOptions] = useState([]);

	const { data: coreReportTypes } = useGetCoreReportTypes();

	useEffect(() => {
		if (coreReportTypes?.status === "success") {
			let options = [];
			coreReportTypes?.data?.reporting_types?.forEach((element) => {
				options.push({ label: element?.label, value: element?.code });
			});
			setTypesOptions(options);
		}
	}, [coreReportTypes]);

	const [reasonId] = useState(item?.id);

	const [formData, setFormData] = useState({
		name: "",
		description: "",
		type: "",
	});

	useEffect(() => {
		if (item) {
			setFormData({
				name: item?.label,
				description: item?.description,
				type: item?.report_types?.map((reportType) => {
					return { label: reportType?.label, value: reportType?.code };
				}),
			});
		}
	}, [item]);

	const {
		mutateAsync: createReportReasonsApi,
		data: createReportReasonsData,
		error: errorCreateReportReason,
		isLoading: creatReasonLoading,
	} = useCreateReportReasons();

	useEffect(() => {
		if (createReportReasonsData) {
			setLoading(false);
			if (createReportReasonsData?.status === "success") {
				CS.showSuccessMessage(createReportReasonsData?.message);
				onSuccessRefetch();
			} else if (createReportReasonsData?.status === "fail") {
				CS.showErrorMessage(createReportReasonsData?.message);
			}
		}
	}, [createReportReasonsData]);

	useEffect(() => {
		if (errorCreateReportReason) {
			setLoading(false);
			CS.showErrorMessage(errorCreateReportReason?.response?.data?.message);
		}
	}, [errorCreateReportReason]);

	const {
		mutateAsync: updateReportReasonsApi,
		error: errorUpdateReason,
		data: updateReasonData,
		isLoading: updateReasonLoading,
	} = useUpdateReportReasons();

	useEffect(() => {
		if (updateReasonData) {
			setLoading(false);
			if (updateReasonData?.status === "success") {
				CS.showSuccessMessage(updateReasonData?.message);
				onSuccessRefetch();
			} else if (updateReasonData?.status === "fail") {
				CS.showErrorMessage(updateReasonData?.message);
			}
		}
	}, [updateReasonData]);

	useEffect(() => {
		if (errorUpdateReason) {
			setLoading(false);
			CS.showErrorMessage(errorUpdateReason?.response?.data?.message);
		}
	}, [errorUpdateReason]);

	const { values, touched, errors, handleChange, handleSubmit } = useFormik({
		initialValues: formData,
		enableReinitialize: true,
		validationSchema: reasonSchema,
		onSubmit: (values) => {
			let report_types = values.type?.map((val) => val.value);
			if (reasonId) {
				updateReportReasonsApi({
					reasonId,
					body: {
						description: values.description,
						is_active: item?.reporting_reason?.is_active,
						report_types,
					},
				});
			} else {
				createReportReasonsApi({
					name: values.name,
					description: values.description,
					report_types,
				});
			}
		},
	});

	useEffect(() => {
		setLoading(updateReasonLoading || creatReasonLoading);
	}, [updateReasonLoading, creatReasonLoading]);

	return (
		<>
			<div className="modal-dialog modal-dialog-scrollable m-0 w-100">
				<div className="modal-content">
					<div className="modal-header">
						<h5 className="modal-title">
							{" "}
							{reasonId ? "Update Reason" : "Add Reason"}
						</h5>
					</div>
					<div className="notification-form modal-body card profile-card password-modal">
						<div className="row">
							<div className="col-md-12">
								<form onSubmit={(event) => handleSubmit(event)}>
									<div className="mb-md-4 mb-3">
										<div className="form-group mb-0">
											<label className="label xl-label" htmlFor="title">
												Name<sup className="text-danger">*</sup>
											</label>
											<div className="w-100 position-relative">
												<input
													className="form-control"
													type="text"
													id="name"
													name="name"
													placeholder="Enter name"
													disabled={reasonId ? true : false}
													value={values.name}
													onChange={handleChange}
												/>
												<div className="error-message-password">
													<span className="text-danger error-msg d-block mb-2">
														{errors.name && touched.name ? errors.name : null}
													</span>
												</div>
											</div>
										</div>
									</div>
									<div className="mb-md-4 mb-3">
										<div className="form-group mb-0">
											<label className="label xl-label">
												Type<sup className="text-danger">*</sup>
											</label>
											<div className="w-100 position-relative">
												<Select
													value={values.type}
													isMulti={true}
													onChange={(val) => {
														let event = {
															target: { name: "type", value: val },
														};
														handleChange(event);
													}}
													options={typesOptions}
												/>
											</div>
											<div className="error-message-password">
												<span className="text-danger error-msg d-block mb-2">
													{errors.type && touched.type ? errors.type : null}
												</span>
											</div>
										</div>
									</div>
									<div className="mb-md-4 mb-3">
										<div className="form-group mb-0">
											<label className="label xl-label" htmlFor="title">
												Description<sup className="text-danger">*</sup>
											</label>
											<div className="w-100 position-relative">
												<input
													className="form-control"
													type="text"
													id="description"
													name="description"
													placeholder="Enter description"
													// disabled={reasonId ? true : false}
													value={values.description}
													onChange={handleChange}
												/>
												<div className="error-message-password">
													<span className="text-danger error-msg d-block mb-2">
														{errors.description && touched.description
															? errors.description
															: null}
													</span>
												</div>
											</div>
										</div>
									</div>

									<div className="mt-5 text-right">
										<button className="btn btn-primary" type="submit">
											{reasonId ? "Update" : "Add"}
										</button>
									</div>
								</form>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default AddUpdate;
